export const ConfidenceChip = ({ score, className = '', dataTestId = 'confidence-chip' }) => {
  const s = Number(score ?? 0);
  let cls = 'chip-danger'; let label = 'Needs verification';
  if (s >= 0.85) { cls = 'chip-success'; label = 'Confirmed'; }
  else if (s >= 0.6) { cls = 'chip-warning'; label = 'Review suggested'; }
  return (
    <span data-testid={dataTestId} className={`chip ${cls} ${className}`} title={`Score: ${s.toFixed(2)}`}>
      {label}
    </span>
  );
};

export const chipLevel = (score) => {
  const s = Number(score ?? 0);
  if (s >= 0.85) return 'success';
  if (s >= 0.6) return 'warning';
  return 'danger';
};
